import _ from "lodash";
import api from "CommonCore/api";

export const schema = {
  displayName: "Person Studienbereich", // Block 2: Studium
  table: [
    {
      field: "psb_pfaid",
      display: "Geplanter Hochschulabschluss",
      type: "select",
      choices: lookup => _.map(_.filter(lookup, l => l.pfa_anzeige == true), l => ({ value: l.pfa_id, label: l.pfa_kbez })),
      inject: ["k_pfaartLookup"],
      selector: lookup => id => _.get(lookup, [id, "pfa_kbez"], ""),
    },
    {
      field: "psb_ksbid",
      display: "Studiengang",
      sortable: true,
      type: "select",
      choices: lookup => _.map(_.filter(lookup, l => l.ksb_anzeige == true), l => ({ value: l.ksb_id, label: l.ksb_bez })),
      inject: ["k_studienbereichLookup"],
      selector: lookup => id => _.get(lookup, [id, "ksb_bez"], ""),
    },
    {
      field: "psb_semester",
      display: "Aktuelles Semester",
      sortable: true,
      maxlength: 2,
      validate: value => {
        if (isNaN(value) || parseInt(value) > 99 || parseInt(value) < 1 || value % 1 != 0 || String(value).indexOf(".") >= 0 || String(value).indexOf(",") >= 0) {
          return "Die Semesteranzahl muss eine bis zu zweistellige Ganzzahl sein";
        }
      },
    },
    {
      field: "psb_student_gueltigab",
      display: "Studienbeginn",
      type: "date",
    },
    {
      field: "psb_student_gueltigbis",
      display: "vorauss. bis",
      type: "date",
    },
    {
      field: "psb_matrikelnummer",
      display: "Matrikelnummer",
      numeralFormat: "0",
      type: "number",
      validate: value => {
        if (value && (isNaN(value) || parseInt(value) > 2147483647 || parseInt(value) < 1 || value % 1 != 0)) {
          return "Die Matrikelnummer muss eine positive Ganzzahl < 2147483648 sein";
        }
      },
      helpText: "Bitte BUW Matrikelnummer angeben, falls vorhanden.",
    },

    {
      field: "psd_studium_beurlaubt_gueltigab",
      display: "falls beurlaubt, seit",
      type: "date",
    },

  ],
};


const desc = {
  id: "psb_id",
  name: "studienbereich",
  endpoint: "/api/shkperson/studienbereich",
  schema,
  breadcrumbs: {
    list: "Studienbereich",
    detail: ba => ba.ba_kbez,
  },
};

const personstudienbereichApi = api(desc);
export default personstudienbereichApi;

